// import $ from 'jquery'
// import printJS from 'print-js'
// import 'print-js/dist/print.css'
// import 'magnific-popup/dist/jquery.magnific-popup' // Probably NOT going to work. Use script loaded instead.
// import 'magnific-popup/dist/magnific-popup.css'

import { IframeOverlayHandler } from './IframeOverlayHandler'
import { getURLFromQuery, hideOnPrint, hidePrintHeaderAndFooter, injectLinkPrefetchIn4g, loadFiles, printCss } from './utilities'

/**
 * global {JQuery & { magnificPopup: MagnificPopup }} $
 * @typedef {{ open: (options: any) => void, close: () => void }} MagnificPopup
 */

/**
 * @return {import('print-js')} printJS
 */
const getPrintJS = () => /** @type {any} */ (window).printJS

/**
* @typedef {{ title?: string, description?: string, url?: string, image?: string, showQRCode?: boolean } & Record<string, any> } QuickAccessItem
* @typedef {{ 
*  showQRCode?: boolean;
*  showIcon?: boolean;
*  showImage?: boolean;
*  showTitleIcon?: boolean;
*  openInIframe?: boolean;
*  usePopup?: boolean;
*  wrapper?: string;
*  openTarget?: '_blank'| '_self' | '_parent' | '_top'
*  }} QuickAccessOptions
* @typedef {{ items: QuickAccessItem[]; options: QuickAccessOptions; }} QuickAccessConfig
*/

const CLOSE_BUTTON_SELECTOR = '.mfp-close'

const MESSAGES_EN = {
    'quick-access-title': 'Quick Access',
}
const MESSAGES_JA = {
    'quick-access-title': 'クイックアクセス'
}
const MESSAGES = {
    en: MESSAGES_EN,
    ja: MESSAGES_JA,
}
const language = 'en' // TODO
const messages = MESSAGES[language]

/**
 * @param {*} schema 
 * @param {Partial<QuickAccessItem>} extra 
 */
export function SchemaToQuickAccessItem(schema, extra = {}) {
    return {
        title: schema.name,
        description: schema.description,
        url: schema.url,
        image: schema.image,
        ...extra,
    }
}

/**
 * Uses theopenweb remote config as a test.
 * @param {string} url
 */
export async function getRemoteQuickAccessConfig(url) {
    const { items, options } = await (await fetch(url)).json()

    /**
     * @type {QuickAccessConfig}
     */
    const config = {
        items,
        options,
    }
    return config
}

export async function attemptGetConfigFromQuery() {
    const url = getURLFromQuery('url')
    if (url) {
        return await getRemoteQuickAccessConfig(url)
    }
}

export class QuickAccess {
    /**
     * @param {QuickAccessItem[]} items 
     * @param {QuickAccessOptions} options 
     */
    constructor(items, options) {
        this.HASH_SELECTOR = '#quick-access'
        this.HASH_SELECTOR_ALIASES = ['#qa']
        this.ALL_HASH_SELECTORS = [this.HASH_SELECTOR, ...this.HASH_SELECTOR_ALIASES]

        this.items = items
        this.options = options
        /**
         * @type {Record<string, null|(() => void)>}
         */
        this.handles = {
            hashchange: null,
        }
    }
    async loadDependencies() {
        await loadFiles([
            "jquery.min.js",
        ], './lib/')
        await loadFiles([
            "print.js",
            "print.css",
            "jquery.magnific-popup.js",
            "magnific-popup.css",
        ], './lib/')
    }
    
    async get() {
        const items = this.items
        const options = this.options

        const ID = 'quick-access-overlay-wrapper'
        const wrapper = document.createElement('div')
        wrapper.setAttribute('id', ID)

        // css
        /**
         * @type {string[]}
         */
        const classes = ['quick-access-item']
        const css = `
    /* Main popup wrapper(mfp magnificent popup with absolute .mfp-container) */
    /* Check if being applied. Set to head, if necessary. */
    .mfp-container {
        overflow: scroll;
        background-color: white;
    }
    .mfp-content {
        min-height: 100%; /* Content use */
    }

    #quick-access-overlay-wrapper {
        background-color: white; /* Usually needed. */
        padding: 10px;
        margin: auto;
        width: 100%;
        border: 1px solid lightgray;
    }

    .quick-access-item {
      text-align: center;
    }
    .quick-access-item a {
      /* display: block; */
      display: inline-block;
    }
    .quick-access-item .c-link-text {
        display: none;
    }
    .quick-access-item.c-use-iframe {
        cursor: pointer;
    }
    .quick-access-item.c-use-iframe:hover {
        opacity: 0.7;
    }
    .quick-access-item.c-use-iframe .c-link {
        display: none!important;
    }
    .quick-access-item.c-use-iframe .c-link-text {
        display: block!important;
    }
    .quick-access-item .c-title-icon img {
        max-width: 48px;
        max-height: 48px;
        margin-right: 10px;
    }

    #quick-access-header {
        text-align: center;
        padding-bottom: 10px;
        width: 100%;
        font-size: 35pt;
        display: block;
        margin: 0 auto;
    }
    #quick-access-list {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 30px 10px;
        /* overflow: scroll; */
        overflow: auto;
        margin: 0 auto;
        max-width: 1000px;
    }

    # Mobile
    only screen and (min-width: 480px) {
        #quick-access-header {
            margin: 0 auto;
            font-size: 15pt;
            background-color: gray;
            color: white;
            padding: 0;
        }

        #quick-access-list {
            grid-template-columns: 'repeat(1, 1fr)!important;';
        }

        button.mfp-close color: 'white'

        .quick-access-item .c-title, .quick-access-item .c-description {
            /*
            Only one line of text css:
            https://stackoverflow.com/questions/7546389/css-overflow-only-1-line-of-text
            Note: This requires setting a width, otherwise, the whole line is used.
            */
            text-overflow: ellipsis; overflow: hidden; white-space: nowrap;
        }
    }

    # Tablet
    only screen and (min-width: 768px)  {

    }

    # Desktop
    only screen and (min-width: 992px) {

    }

    # Huge
    only screen and (min-width: 1280px) {

    }
    `
        const styleElement = document.createElement('style')
        styleElement.innerHTML = css
        wrapper.appendChild(styleElement)

        // Title
        const TOP_HEADER_ID = 'quick-access-header'
        const h2 = document.createElement('h2')
        h2.setAttribute('id', TOP_HEADER_ID)
        h2.textContent = messages['quick-access-title']
        wrapper.appendChild(h2)

        // List
        const LIST_ID = 'quick-access-list'
        const innerWrapper = document.createElement('div')
        innerWrapper.setAttribute('id', LIST_ID)

        // Iframe handling.
        /**
         * @type {IframeOverlayHandler|null}
         */
        let iframeOverlayHandler = null
        if (options.openInIframe) {
            iframeOverlayHandler = new IframeOverlayHandler(items.filter(item => !!item.url).map(item => item.url || ''))
            iframeOverlayHandler.addControls()

            // css
            classes.push('c-use-iframe')
        }

        const openTarget = options.openTarget || '_blank'

        // Item start
        const promises = items.map(async item => {
            const title = item.title || ''
            const description = item.description || ''
            const url = item.url || ''
            const img = item.image ? `<img src="${item.image}" alt="${title}">` : ''
            // const qrCode = options.showQRCode && url ? `<img src="${getQRCode(url, 'image')}" alt="${url}">` : '' // Currently img not supported.
            const qrCodeString = options.showQRCode && url ? getQRCode(url, 'html') : ''
            const qrCode = qrCodeString ? (await loadRemoteXML(qrCodeString)).innerHTML : '' // TODO: xml? What is this?
            const titleIcon = options.showIcon ? img : ''
            const mainImage = options.showImage ? img : ''

            if (url && Array.from(document.querySelectorAll('link')).filter(i => i.href === url).length === 0) {
                injectLinkPrefetchIn4g(url)
            }

            const div = document.createElement('div')
            div.setAttribute('class', 'quick-access-item')
            div.addEventListener('click', function (ev) {
                const onHandle = () => {
                    ev.preventDefault()
                }

                // Iframe handling.
                if (iframeOverlayHandler && options.openInIframe) {
                    console.debug('Handling item click')
                    onHandle()
                    // const iframeOverlayHandler = new IframeOverlayHandler([]) // SHOULD ideally be created outside of list.
                    iframeOverlayHandler.show(url)
                }
            })
            div.innerHTML = `
      <div class="${classes.join(' ')}">
        <div>
          <h2 class="c-title">
            <span class="c-title-icon">${titleIcon}</span>
            <span>${title}</span>
          </h2>
          <p class="c-description">${description}</p>
        </div>
        <div>
          <div class="c-img-wrapper">
            ${mainImage}
          </div>
          <div class="c-qr-code-wrapper">
            <span class="c-qr-code">
                ${qrCode}
            </span>
            <span class="c-link">
              <a target="${openTarget}" rel="noopener noreferrer" href="${url}">${url}</a>
            </span>
            <span class="c-link-text">
                ${url}
            </span>
          </div>
        </div>
      </div>
      `
            return div
        });
        (await Promise.all(promises)).forEach(element => {
            innerWrapper.appendChild(element)
        });
        // Item end
        wrapper.appendChild(innerWrapper)

        // Print button
        const PRINT_BUTTON_ID = 'quick-access-print-button'
        const printButton = document.createElement('input')
        printButton.setAttribute('id', PRINT_BUTTON_ID)
        printButton.setAttribute('type', 'button')
        printButton.value = '🖨' // Alternative: https://materialdesignicons.com/ "printer"
        printButton.addEventListener('click', () => {
            // https://printjs.crabbly.com/ "HTML Printing"
            // https://github.com/crabbly/print.js
            // @ts-ignore
            // eslint-disable-next-line no-undef
            // ignoreElements: [`#${PRINT_BUTTON_ID}`, /* CLOSE BUTTON HAS NO ID SO DOING VIA "style" */] // Not working.
            const style = [
                hideOnPrint([
                    CLOSE_BUTTON_SELECTOR,
                    `#${PRINT_BUTTON_ID}`,
                    `#${TOP_HEADER_ID}` // Doesn't style properly so hide.
                ]),
                hidePrintHeaderAndFooter(),
                printCss(`
                
          body {
            zoom: 80%;
            width: 100%;
            height: 100%;
            overflow: hidden!important;
          }
          * {
            overflow: hidden!important;
          }
          #quick-access-list {
            margin: 0!important;
          }
          #quick-access-overlay-wrapper {
            border: none!important;
          }
          #${ID} {
            width: 95%
            height: auto;
          }
        `)
            ].join('');
            getPrintJS()({ printable: ID, type: 'html', targetStyles: ['*'], style })
            // printJS(ID, 'html')
            // window.print() // Backup
        })
        // printButton.onclick = window.print // TEMP SOLUTION
        // TODO: Don't show during print.
        printButton.style.margin = '10px'
        printButton.style.padding = '1px'
        printButton.style.fontSize = '30px'

        const footer = document.createElement('div')
        footer.style.display = 'block'
        footer.style.textAlign = 'right'
        footer.appendChild(printButton)

        wrapper.appendChild(footer)

        return wrapper
    }

    /**
     * Add to DOM(No popup)
     */
    async applyToDOM() {
        const wrapperSelector = this.options.wrapper || 'body'
        const wrapper = document.querySelector(wrapperSelector)
        if (!wrapper) throw new Error('No wrapper')
        wrapper.appendChild(await this.get())
    }

    /**
     * Show as popup
     */
    async show() {
        console.debug('show')
        const wrapper = await this.get()

        // Popup
        // popup(wrapper.outerHTML)
        popup(wrapper) // TODO: Don't show close during print.
    }

    /**
     * Hide popup
     */
    hide() {
        console.debug('hide')
        closePopup()
    }

    /**
     * Automatic handling.
    */
    setup() {
        const handle = () => {
            this.attemptOpenFromCurrentUrl()
        }
        handle()
        const watchHashChanges = () => {
            window.addEventListener('hashchange', handle)
            this.handles.hashchange = handle
        }
        watchHashChanges()
    }

    destroy() {
        console.debug('destroy')
        this.hide()
        if (this.handles.hashchange) {
            window.removeEventListener('hashchange', this.handles.hashchange)
            this.handles.hashchange = null
        }
    }

    attemptOpenFromCurrentUrl() {
        const options = this.options
        const { usePopup } = options

        if (this.isQuickAccessSetInCurrentUrl()) {
            if (usePopup) {
                this.show()
            } else {
                this.applyToDOM()
            }
        }
    }

    isQuickAccessSetInCurrentUrl() {
        return this.ALL_HASH_SELECTORS.includes(location.hash)
    }
}

/**
 * @returns {MagnificPopup}
 */
function getMagnificPopup() {
    return /** @type {import('jquery') & any} */ ($).magnificPopup
}

/**
 * Update: $.magnificPopup.updateItemHTML();
 * Close: $.magnificPopup.close()
 * 
 * Change close button style: https://github.com/dimsemenov/Magnific-Popup/issues/1041
 * 
 * @see https://dimsemenov.com/plugins/magnific-popup/documentation.html
 * @param {PopupData} popupData 
 */
function popup(popupData) {
    // Translations: https://dimsemenov.com/plugins/magnific-popup/documentation.html#translating
    getMagnificPopup().open({ // Open directly via API
        items: [
            {
                // Element seems to work, but the API only mentions the following so standardizing below: can be a HTML string, jQuery object, or CSS selector
                src: popupData instanceof Element ? $(popupData) : popupData, // https://codepen.io/dimsemenov/pen/DdpJeN shows that Element AND JqueryObject can be used.
                type: 'inline' // inline = HTML
            }
        ],
        close: function () {
            // Will fire when popup is closed
            console.debug('popup closed')
        }
    })

    return () => getMagnificPopup().close()
}

function closePopup() {
    getMagnificPopup().close()
}

/**
 * @typedef {string|Element} PopupData
 */

/**
 * TODO: Link with same function on theopenweb.jp
 * @param {string} url 
 * @param {Element} [element]
 */
async function loadRemoteXML(url, element) {
    if (!element) {
        element = document.createElement('div')
        // document.body.appendChild(element)
    }
    const text = await (await fetch(url)).text() // Is an xml string with svg inside.
    element.innerHTML = text

    return element
}

/**
 * @see https://gitlab.com/dammyg/qr-code-generator
 * @param {string} url
 * @param {'html'|'iframe'} [type]
 * @example getQRCode('https://theopenweb.info', 'html')
 * @example getQRCode('https://theopenweb.info', 'iframe')
 */
function getQRCode(url, type = 'html') {
    const QR_CODE_GENERATOR_URL = 'https://theopenweb.info/apps/qr-code-generator'
    if (type === 'iframe') {
        const createQRCodeOnlyURL = /** @param {string} u */ (u) => `${QR_CODE_GENERATOR_URL}?url=${window.encodeURIComponent(u)}&qrcode-only`
        return createQRCodeOnlyURL(url) // iframe
    } else if (type === 'html') {
        const createQRCodeImageURL = /** @param {string} u */ (u) => `${QR_CODE_GENERATOR_URL}/api?input=${window.encodeURIComponent(u)}&size=200`
        return createQRCodeImageURL(url) // img
    } else {
        throw new Error(`Invalid type: ${type}`)
    }
}
